"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.membership = void 0;
exports.membership = {
    id: '11111111-1111-1111-1111-111111111111',
    membership_definition_id: '11111111-2222-2222-2222-11111111111'
};
